/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import type { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import type { ExtractInjectionAPI, UiComponentFactoryParams } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../../aiPluginType';

import { DiscardSessionScreen } from './screens/Discard';
import { ErrorSessionScreen } from './screens/Error';
import { LoadingSessionScreen } from './screens/Loading';
import { PromptSessionScreen } from './screens/Prompt';
import { useUIState } from './useUIState';

export interface SessionUIComponentProps {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	appearance: UiComponentFactoryParams['appearance'];
	providerFactory: ProviderFactory;
}

export function SessionUIComponent({ api, appearance, providerFactory }: SessionUIComponentProps) {
	const [state, dispatch] = useUIState(api);

	switch (state) {
		case 'discard':
			return <DiscardSessionScreen api={api} dispatch={dispatch} appearance={appearance} />;
		case 'loading':
			return (
				<LoadingSessionScreen
					api={api}
					appearance={appearance}
					dispatch={dispatch}
					providerFactory={providerFactory}
				/>
			);
		case 'error':
			return <ErrorSessionScreen api={api} appearance={appearance} dispatch={dispatch} />;
		case 'prompt':
			return <PromptSessionScreen api={api} appearance={appearance} dispatch={dispatch} />;
		case 'idle':
		default:
			return null;
	}
}
